import { Canvas } from "@react-three/fiber";
import React, { Suspense, useState, useRef } from "react";
import { angleToRadians } from "../../utils/angle";
import {
  OrbitControls,
  Float,
  Environment,
  ContactShadows,
  PerspectiveCamera,
} from "@react-three/drei";

import Effects from "../Effects";

import { useFrame } from "react-three-fiber";

import AvaInterface from "../AvaInterface";
import SecureItem from "../Item";
import * as TWEEN from "@tweenjs/tween.js";

const defaultCamera = [-0.1, 1.7, 1.65];
// const defaultBackground = "dawn";

const defaultCameras = [
  {
    value: [-0.1, 1.7, 1.65],
    name: "Default",
    target: [0, 1.8, -0.05],
    rotation: [0, 0, 0],
    rotate: true,
    key: 0,
    next: 1,
    minDistance: 0.86,
    maxDistance: 1.9,
  },
  {
    value: [-0.0123, 2.05, 0.3],
    name: "Heart",
    target: [0, 2.05, -0.05],
    rotation: [0, 0, 0],
    rotate: false,
    key: 2,
    next: 2,
  },
  {
    value: [-0.15, 2.27, 0.309],
    name: "Head",
    target: [0, 2.25, -0.05],
    rotation: [0, 0, 0],
    rotate: false,
    key: 1,
    next: 0,
    minDistance: 0.44,
    maxDistance: 1,
  },
];
const backgroundColor = "black";
// const maxCameraDistance = 1.9;
// const minCameraDistance = 0.485;
// const cameraTolerance = 0.1;

// const {
//   calcPlaneDistance,
//   calcNewCoords,
// } = require("../../utils/canvasFunctions");

// extend({ UnrealBloomPass });

const AvaCanvas = (props) => {
  const [cameraPosition, setCameraPosition] = useState(defaultCamera);
  const [animation, setAnimation] = useState("");
  const [cameraAngle, setCameraAngle] = useState(Math.PI / 2);
  const [cameraZoom, setCameraZoom] = useState(1);
  const orbitControlsRef = useRef(null);
  const [selectedCamera, setSelectedCamera] = useState("Default");
  const [autoRotate, setAutoRotate] = useState(false);
  const [notAO, setNotAO] = useState(true);
  const [minCameraDistance, setMinCameraDistance] = useState(0.86);
  const [maxCameraDistance, setMaxCameraDistance] = useState(1.9);
  const [liveBackgroundEnabled, setLiveBackgroundEnabled] = useState(true);
  const canvasRef = useRef(null);
  var renderer;

  function updateAutoRotate(rotate) {
    // console.log(rotate);
    // console.log(orbitControlsRef);
    orbitControlsRef.current.autoRotate = rotate;
    setAutoRotate(rotate);
    orbitControlsRef.current.update();
  }

  function updateAnimationList(list) {
    // console.log(list);
    if (list[1]) {
      updateAnimation(list[1]);
    } else if (list[0]) {
      updateAnimation(list[0]);
    }
  }

  function updateCameraAnimation(cameraKey) {
    setSelectedCamera(cameraKey.name);
    updateAutoRotate(cameraKey.rotate);
    const camera = orbitControlsRef.current;
    const coords = {
      x: camera.object.position.x,
      y: camera.object.position.y,
      z: camera.object.position.z,
    };
    const rotation = {
      x: camera.object.rotation.x,
      y: camera.object.rotation.y,
      z: camera.object.rotation.z,
    };
    const target = {
      x: camera.target.x,
      y: camera.target.y,
      z: camera.target.z,
    };

    new TWEEN.Tween(target)
      .to({
        x: cameraKey.target[0],
        y: cameraKey.target[1],
        z: cameraKey.target[2],
      })
      .easing(TWEEN.Easing.Quadratic.InOut)
      .onUpdate(() => camera.target.set(target.x, target.y, target.z))
      .start();

    new TWEEN.Tween(coords)
      .to({
        x: cameraKey.value[0],
        y: cameraKey.value[1],
        z: cameraKey.value[2],
      })
      .easing(TWEEN.Easing.Quadratic.InOut)
      .onUpdate(() => camera.object.position.set(coords.x, coords.y, coords.z))
      .start();

    new TWEEN.Tween(rotation)
      .to({
        x: cameraKey.rotation[0],
        y: cameraKey.rotation[1],
        z: cameraKey.rotation[2],
      })
      .easing(TWEEN.Easing.Quadratic.InOut)
      .onUpdate(() => {
        camera.object.rotation.set(rotation.x, rotation.y, rotation.z);
        camera.update();
      })
      .start();
    let distance = {
      minDistance: minCameraDistance,
      maxDistance: maxCameraDistance,
    };
    new TWEEN.Tween(distance)
      .to({
        minDistance: cameraKey.minDistance,
        maxDistance: cameraKey.maxDistance,
      })
      .easing(TWEEN.Easing.Quadratic.InOut)
      .onUpdate(() => {
        setMinCameraDistance(distance.minDistance);
        setMaxCameraDistance(distance.maxDistance);
      })
      .start();
  }

  function updateAnimation(animationName) {
    setAnimation(animationName);
  }

  function Dolly() {
    useFrame((state) => {
      orbitControlsRef.current.update();
      TWEEN.update();

      setCameraAngle(orbitControlsRef.current.getPolarAngle());
      setCameraZoom(
        3.9 / (orbitControlsRef.current.getDistance() + 2) // 2.307 is the distance from the camera to the target, 2 is added to translate the max zoom from 700% to 186%
      );
    });
    return null;
  }
  // console.log(canvasRef);
  return (
    <div
      className="canvas"
      style={{
        background: backgroundColor,
        // backgroundImage: `url('https://endpoint-gjc6u42x5a-uc.a.run.app/api/ava_background/edition/${props.match.params.item}')`,
        // backgroundSize: "auto " + cameraZoom * 120 + "%",
        // backgroundPosition: "center",
        // backgroundRepeat: "no-repeat",
      }}
    >
      <center>
        <video
          playsInline
          autoPlay
          muted
          loop
          width={cameraZoom * 100 + "%"}
          height={cameraZoom * 100 + "%"}
          style={{
            opacity: liveBackgroundEnabled ? 1 : 0,
            transition: "opacity 1s",
          }}
        >
          <source
            src={`https://endpoint-gjc6u42x5a-uc.a.run.app/api/ava_background/token/${
              props.match.params.token_id ? props.match.params.token_id : null
            }`}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </center>

      <AvaInterface
        defaultCameras={defaultCameras}
        updateCameraPosition={updateCameraAnimation}
        setCameraPosition={setCameraPosition}
        cameraAngle={cameraAngle}
        cameraZoom={cameraZoom}
        selectedCamera={selectedCamera}
        liveBackgroundEnabled={liveBackgroundEnabled}
        setLiveBackgroundEnabled={setLiveBackgroundEnabled}
      />
      <Canvas id="canvas" ref={canvasRef}>
        {!notAO && <directionalLight position={[0, 2.5, -2]} intensity={0.2} />}
        <directionalLight
          position={[3, 1.75, 0.25]}
          intensity={1.5}
          color="#ea9393"
          // Front key
        />
        <directionalLight
          position={[-2, 3.4, -1]}
          intensity={1}
          color="#a6eacb"
          // Back light
        />
        <directionalLight
          position={[-2, 1.5, 0.1]}
          intensity={0.25}
          color="lightblue"
          // Front fill
        />
        <Suspense fallback={null}>
          <PerspectiveCamera
            makeDefault
            position={cameraPosition}
            fov={50}
          ></PerspectiveCamera>
          {/* {/* <EffectsWrapper> */}
          <Effects />
          {/* <renderPass attachArray="passes" scene={scene} camera={camera} />
            <sSAOPass
              attachArray="passes"
              args={[scene, camera, 1024, 1024]}
              kernelRadius={0.8}
              maxDistance={0.4}
            />{" "} */}
          {/* <unrealBloomPass
              attachArray="passes"
              args={[undefined, 0.6, 1, 1.9]}
            /> */}
          {/* <shaderPass
              attachArray="passes"
              args={[FXAAShader]}
              material-uniforms-resolution-value={[
                1 / window.size.width,
                1 / window.size.height,
              ]}
            /> */}
          {/* </Effects> */}
          {/* </EffectsWrapper> */}
          <Float
            position={[0, 1.22, 0]}
            rotation={[0, 0, 0]}
            rotationIntensity={0}
            floatIntensity={0}
            speed={4}
          >
            <SecureItem
              token_id={
                props.match.params.token_id ? props.match.params.token_id : null
              }
              collection={"Avas"}
              setAnimations={updateAnimationList}
              animation={animation}
              setNotAO={setNotAO}
              camera={orbitControlsRef.current}
              renderer={renderer}
            />
          </Float>
          {
            <Environment
              background={false}
              files={`https://endpoint-gjc6u42x5a-uc.a.run.app/api/ava_hdri/token/${
                props.match.params.token_id ? props.match.params.token_id : "10"
              }`}
            />
          }
          <ContactShadows
            opacity={0}
            scale={10}
            blur={1}
            far={10}
            resolution={256}
            color="#808080"
          />
        </Suspense>

        <OrbitControls
          ref={orbitControlsRef}
          minPolarAngle={angleToRadians(10)}
          maxPolarAngle={angleToRadians(140)}
          target={[0, 1.8, -0.05]}
          enableZoom={true}
          enablePan={true}
          maxDistance={maxCameraDistance}
          minDistance={minCameraDistance}
          autoRotate={autoRotate}
        />
        <Dolly />
      </Canvas>
    </div>
  );
};

export default AvaCanvas;
